import { Box, Grid, Button, TextField, Typography } from "@mui/material";
import { React, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sizes } from "../scenarioSetupNewUtils";
import {
  setState,
  submitScenario,
  saveScenario,
  verifyScenario,
} from "../scenarioSetupNewSlice";

import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import SaveIcon from "@mui/icons-material/Save";
import ExportExcelPDF from "./ExportExcelPDF";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import moment from "moment";
import CollapseSection from "../../../../components/ui/CollapseSection";


const commonHeight = sizes.h35;
const LW = sizes.w500;

export default function Summary() {
    
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const dispatch = useDispatch();
  const setupState = useSelector((store) => store.scenarioSetupNew);
  const {
    scenarioName,
    selectedCountry,
    createToDate,
    periodType,
    selectedPGs,
    selectedCustsCGs,
    customerBreakdownType,
    customerBreakdown,
    skuBreakdown,
    comments,
    selectedDSs,
    scDSA,
    dataSources,
    countryID,
    emailNotification,
    primaryDataSourceID,
    minimumQuota,
    editMode,
    email,
    createFromDate,
    sentToSAP,
    DSMHigh,
    DSMMed,
    DSMLow,
    DSMOth,
    selectedPDS,
    SafetyMargin,
    criticalityId,
    selectedScSTQ,
    selectedScUB,
    selectedScModifySTQ,
    selectedLinearTrend,
    selectedRunRate,
    selectedConsensus,
    selectedPreviousYear,
    quotaDeviationPercentage,
    modificationDeviationPercentage,
    selectedDefaultInitialForecast,
    scenarioExternalDataSource,
    scenarioExternalDataSourceSKU,
    MarketShareTimePeriod,
    selectedReferenceSKU,
    manually_defineMSList,
    marketShareComparisonList,
    editScDSAData,
    refList,
    isCustomerChanged
  } = setupState;
  const [CustomerList, setCustomerList] = useState(
    selectedCustsCGs ? selectedCustsCGs : []
  );
  const [isAscByName, setAscByName] = useState(false);
  const [isAscByNumber, setAscByNumber] = useState(false);
  useEffect(() => {
    setCustomerList(selectedCustsCGs ? selectedCustsCGs : []);
  }, [selectedCustsCGs]);
  const listToNameString = (list, type) => {
    let nameString = "";

    let filteredList = [];
    if (type == "P")
      filteredList = list
        .filter(
          (item) => item.type === type || item.hasOwnProperty("productID")
        )
        .map((item) => (item.name ? item.name : item.productName));
    else if (type == "PG")
      filteredList = list
        .filter(
          (item) => item.type === type || item.hasOwnProperty("productGroupID")
        )
        .map((item) => (item.name ? item.name : item.productGroupName));
    else if (type == "C")
      filteredList = list
        .filter(
          (item) => item.type === type || item.hasOwnProperty("customerID")
        )
        .map((item) => (item.name ? item.name : item.customerName));
    else if (type == "CG")
      filteredList = list
        .filter(
          (item) => item.type === type || item.hasOwnProperty("customerGroupID")
        )
        .map((item) => (item.name ? item.name : item.customerGroupName));

    if (type != "C") nameString = filteredList.join(", ");
    else nameString = filteredList.join("\n");

    // for (let i = 0; i < list.length; ++i) {
    // 	const item = list[i];
    // 	if (item.type === type) {
    // 		nameString += `${item.name}, `;
    // 	}
    // }
    return nameString;
  };
  const listToNameStringCustomers = (list, type) => {
    let nameString = "";
    let listItems = JSON.parse(JSON.stringify(list));
    let filteredList = [];
    filteredList = listItems
      .filter((item) => item.type === type || item.hasOwnProperty("customerID"))
      .map((item) => (item.name ? item.name : item.customerName));

    nameString = filteredList.join("\n");
    return nameString;
  };
  const getItemText = (item) => {
    if (item.hasOwnProperty("name")) {
      return item.name;
    } else if (item.hasOwnProperty("productGroupName")) {
      return item.productGroupName;
    } else if (item.hasOwnProperty("productName")) {
      return item.productName;
    } else if (item.hasOwnProperty("customerGroupName")) {
      return item.customerGroupName;
    } else if (item.hasOwnProperty("customerName")) {
      return item.customerName;
    }
  };
  const getItemNumber = (item) => {
    if (item.hasOwnProperty("id")) {
      return item.sapCustomerNumber ? item.sapCustomerNumber : item.cip;
    } else if (item.hasOwnProperty("productGroupID")) {
      return 0;
    } else if (item.hasOwnProperty("productID")) {
      return item.clientProductCode;
    } else if (item.hasOwnProperty("customerGroupID")) {
      return 0;
    } else if (item.hasOwnProperty("customerID")) {
      return item.sapCustomerNumber;
    }
  };
  const handleClick = (type) => {
    if (type === "name") {
      if (!isAscByName) {
        let list = JSON.parse(JSON.stringify(CustomerList));
        list = list.sort((a, b) =>
          getItemText(a).toLowerCase().trim() >
          getItemText(b).toLowerCase().trim()
            ? 1
            : -1
        );
        setCustomerList(list);
        setAscByName(true);
      } else {
        let list = JSON.parse(JSON.stringify(CustomerList));
        list = list.sort((a, b) =>
          getItemText(a).toLowerCase().trim() <
          getItemText(b).toLowerCase().trim()
            ? 1
            : -1
        );
        setCustomerList(list);
        setAscByName(false);
      }
    } else {
      if (!isAscByNumber) {
        let list = JSON.parse(JSON.stringify(CustomerList));
        list = list.sort((a, b) =>
          getItemNumber(a) > getItemNumber(b) ? 1 : -1
        );
        setCustomerList(list);
        setAscByNumber(true);
      } else {
        let list = JSON.parse(JSON.stringify(CustomerList));
        list = list.sort((a, b) =>
          getItemNumber(a) < getItemNumber(b) ? 1 : -1
        );
        setCustomerList(list);
        setAscByNumber(false);
      }
    }
  };

  const getDataSourcesString = () => {
    let dsString = "";
    dsString = selectedDSs.join(", ");
    // for (let i = 0; i < selectedDSs.length; ++i) {
    // 	dsString += `${selectedDSs[i]}, `;
    // }
    return dsString;
  };

  const handleStateUpdate = (event, stateName) => {
    const value = event.target.value;
    dispatch(setState(stateName, value));
  };

  const showMessage = (message, severity) => {
    dispatch(setState("message", message));
    dispatch(setState("severity", severity));
    dispatch(setState("messageOpen", true));
  };

  const validFromDate = (date) => {
    if (periodType.length <= 0) {
      showMessage("Please select period type first", "info");
      return false;
    }
    if (periodType === "Weekly" && date.day() !== 1) {
      showMessage("Chosen day must be Monday for weekly period type", "info");
      return false;
    }
    if (periodType === "Monthly" && date.date() !== 1) {
      showMessage(
        "Chosen day must be first day of month for monthly period type",
        "info"
      );
      return false;
    }
    if (date < dayjs() && periodType === "Weekly" && date.day() !== 1) {
      showMessage("Past dates cannot be selected", "info");
      return false;
    }
    if (date < dayjs() && periodType === "Monthly" && date.date() !== 1) {
      showMessage("Past dates cannot be selected", "info");
      return false;
    }
    if (date > createToDate) {
      showMessage("Invalid from date", "info");
      return false;
    }
    return true;
  };

  const validToDate = (date) => {
    if (periodType.length <= 0) {
      showMessage("Please select period type first", "info");
      return false;
    }
    if (periodType === "Weekly" && date.day() !== 0) {
      showMessage("Chosen day must be Sunday for weekly period type", "info");
      return false;
    }
    if (periodType === "Monthly" && !date.isSame(date.endOf("month"), "day")) {
      showMessage(
        "Chosen day must be last day of month for monthly period type",
        "info"
      );
      return false;
    }
    if (date < dayjs()) {
      showMessage("Past dates cannot be selected", "info");
      return false;
    }
    if (date < createFromDate) {
      showMessage("Invalid from date", "info");
      return false;
    }
    return true;
  };

  const validDate = () => {
    return validFromDate(createFromDate) && validToDate(createToDate);
  };

  const submitDataIsValid = () => {
    if (selectedCountry.length <= 0) {
      showMessage("Please select a country", "info");
      dispatch(setState("section_Scenario_Parameteres",true));
      return false;
    }
    if (scenarioName.length <= 0) {
      showMessage("Please enter scenario name", "info");
      dispatch(setState("section_Scenario_Parameteres",true));
      return false;
    }
    if (periodType.length <= 0) {
      showMessage("Please select period type", "info");
      dispatch(setState("section_Scenario_Parameteres",true));
      return false;
    }
    if (periodType.length <= 0) {
      showMessage("Please select period type", "info");
      dispatch(setState("section_Scenario_Parameteres",true));
      return false;
    }
    if (!validDate()) {
      dispatch(setState("section_Scenario_Parameteres",true));
      return false;
    }
    if (selectedPGs.length <= 0) {
      showMessage("At least one SKU or Product Group must be selected", "info");
      dispatch(setState("section_SKU", true));
      return false;
    }
    if (selectedCustsCGs.length <= 0) {
      showMessage(
        "At least one Customer or Customer Group must be selected",
        "info"
      );
      dispatch(setState("section_Customer", true));
      return false;
    }
    if (selectedDSs.length <= 0) {
      showMessage("At least one Data Source must be selected", "info");
      dispatch(setState("section_Datasources", true));
      return false;
    }
    if (selectedPDS.length <= 0) {
      showMessage("Primary data source must be selected", "info");
      dispatch(setState("section_Datasources", true));
      return false;
    }
    if (criticalityId.length <= 0) {
      showMessage("Scenario Criticality must be selected", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (selectedScSTQ.length <= 0) {
      showMessage("Scenario Stick to Quota must be selected", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if(selectedScUB.length <= 0) {
      showMessage("Scenario Unblock Full Order must be selected", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if(selectedScModifySTQ.length <= 0) {
      showMessage("Scenario Modify + Stick to Quota must be selected", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (skuBreakdown.length <= 0) {
      showMessage("SKU breakdown methodology must be selected", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (customerBreakdownType.length <= 0) {
      showMessage("Customer breakdown type must be selected", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (
      (customerBreakdownType == "Scenario SKUs" ||
        customerBreakdownType == "Reference SKUs" ||
        customerBreakdownType == "Dynamic Market Share") &&
      customerBreakdown === ""
    ) {
      showMessage("Customer breakdown period must be selected", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (
      customerBreakdownType == "External" &&
      scenarioExternalDataSource.length <= 0
    ) {
      showMessage("Please upload External Market share for customers", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (
      customerBreakdownType == "Manually Defined" && (isCustomerChanged === true ||
        manually_defineMSList.length <= 0 )
    ) {
      showMessage("Please upload Manually Defined share for customers", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (
      customerBreakdownType == "Reference SKUs" &&
      selectedReferenceSKU.length <= 0
    ) {
      showMessage(
        "Reference SKU definition in Market share comparison is not available.",
        "info"
      );
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (
      skuBreakdown == "External" &&
      scenarioExternalDataSourceSKU.length <= 0
    ) {
      showMessage("Please upload External Market share for customers", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (selectedLinearTrend == "") {
      showMessage("Linear Trend should be selected", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (selectedRunRate == "") {
      showMessage("Run Rate should be selected", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (selectedConsensus == "") {
      showMessage("Cons-FC Based Quantity should be selected", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (selectedPreviousYear == "") {
      showMessage("Previous Year should be selected", "info");
      return false;
    }
    if (selectedDefaultInitialForecast == "") {
      showMessage("Default Initial Forecast should be selected", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    // let isBufferAdded = false;
    // for (let i = 0; i < selectedCustsCGs.length; i++) {
    //   if (selectedCustsCGs[i].hasOwnProperty("isBuffer")) {
    //     if (selectedCustsCGs[i].isBuffer === 1) {
    //       isBufferAdded = true;
    //       break;
    //     }
    //   }
    // }
    // if (!isBufferAdded) {
    //   showMessage("Please include a Buffer Customer in the Scenario", "info");
    //   return false;
    // }
    return true;
  };

  const getIDsFromList = (list, unit) => {
    console.log("Create_Summary_getIDsFromList", list);
    let unitStr = "";
    let groupStr = "";
    const size = list.length;
    for (let i = 0; i < size; ++i) {
      if (
        list[i].hasOwnProperty("id") &&
        list[i].type != undefined &&
        list[i].type != null
      ) {
        if (list[i].type === unit) {
          unitStr += i === size - 1 ? list[i].id : list[i].id + ",";
        } else {
          groupStr += i === size - 1 ? list[i].id : list[i].id + ",";
        }
      } else if (list[i].hasOwnProperty("productID")) {
        unitStr += i === size - 1 ? list[i].productID : list[i].productID + ",";
      } else if (list[i].hasOwnProperty("customerID")) {
        unitStr +=
          i === size - 1 ? list[i].customerID : list[i].customerID + ",";
      } else if (list[i].hasOwnProperty("customerGroupID")) {
        groupStr +=
          i === size - 1
            ? list[i].customerGroupID
            : list[i].customerGroupID + ",";
      } else if (list[i].hasOwnProperty("productGroupID")) {
        groupStr +=
          i === size - 1
            ? list[i].productGroupID
            : list[i].productGroupID + ",";
      }
    }
    if (unitStr.endsWith(",")) unitStr = unitStr.slice(0, -1);
    if (groupStr.endsWith(",")) groupStr = groupStr.slice(0, -1);
    console.log("Create_Summary_getIDsFromList", { unitStr, groupStr });
    return {
      unitStr,
      groupStr,
    };
  };

  const getPipeSeparatedString = (list) => {
    let str = "";
    for (let i = 0; i < list.length; ++i) {
      str += i === list.length - 1 ? list[i] : list[i] + "|";
    }
    return str;
  };

  const prepareScenarioDSAlignment = () => {
    let scDSList = [];
    if (scDSA.length > 0) {
      for (let i = 0; i < scDSA.length; ++i) {
        const item = scDSA[i];
        const id = selectedDSs.findIndex((x) => x === item.dataSourceName);
        if (id > -1) {
          const obj = {
            DataSourceID: item.dataSourceID,
            skuid: item.skuid,
            productGroupID: item.productGroupID,
            MeasureNumber: item.MeasureNumber,
          };
          const attributeList = item.attributes;
          for (let j = 0; j < attributeList.length; ++j) {
            const attrItem = attributeList[j];
            if (
              attrItem.attributeName !== "hide" &&
              attrItem.selectedAttributeValues.length > 0
            ) {
              const objPropName = `AttributeFilter${j + 1}`;
              const pipeSeparatedString = getPipeSeparatedString(
                attrItem.selectedAttributeValues
              );
              obj[objPropName] = pipeSeparatedString;
            }
          }
          scDSList.push(obj);
        }
      }
    } else if (editScDSAData.length > 0) {
      for (let i = 0; i < editScDSAData.length; ++i) {
        const item = editScDSAData[i];
        const id = selectedDSs.findIndex((x) => x === item.dataSourceName);
        let measureValue;
        if (item.measure.length > 0) {
          measureValue = item.measure[0].measureValue;
        }
        if (id > -1) {
          const obj = {
            DataSourceID: item.dataSourceID,
            skuid: item.skuid,
            productGroupID: item.productGroupID,
            MeasureNumber: measureValue,
          };
          const attributeList = item.attributes;
          for (let j = 0; j < attributeList.length; ++j) {
            const attrItem = attributeList[j];

            const objPropName = `AttributeFilter${j + 1}`;
            const pipeSeparatedString = attrItem.attributeValues[0];
            obj[objPropName] = pipeSeparatedString;
          }
          scDSList.push(obj);
        }
      }
    } else {
      for (let i = 0; i < selectedDSs.length; ++i) {
        const name = selectedDSs[i];
        const DataSourceID = dataSources.find(
          (source) => source.dataSourceName === name
        ).dataSourceID;
        const obj = {
          DataSourceID,
        };
        scDSList.push(obj);
      }
    }
    // const idx = selectedDSs.findIndex((x) => x === "TTM");
    // if (idx > -1) {
    //   const obj = {
    //     DataSourceID: 1,
    //   };
    //   scDSList.push(obj);
    // }
    for(let i= 0; i< selectedDSs.length; i++){
      const name = selectedDSs[i];
      const DataSourceID = dataSources.find(
          (source) => source.dataSourceName === name
      ).dataSourceID;
      const id = scDSList.findIndex((x) => x.DataSourceID === DataSourceID);
      if(id === -1){
        const obj = {
          DataSourceID,
        };
        scDSList.push(obj);
      }
    }
    return scDSList;
  };

  const changeDateFormat = (date) => {
    const year = date.year();
    const month =
      date.month() + 1 < 10 ? `0${date.month() + 1}` : date.month() + 1;
    const day = date.date() < 10 ? `0${date.date()}` : date.date();
    const time = "T00:00:00.000Z";
    const d = `${year}-${month}-${day}${time}`;
    return d;
  };
  const changeDateFormatforComments = () => {
    const date = new Date();
    const year = date.getYear() + 1900;
    const month =
      date.getMonth() + 1 < 10
        ? `0${date.getMonth() + 1}`
        : date.getMonth() + 1;
    const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const sec = date.getSeconds();
    const time = `T${hours}:${minutes}:${sec}.000Z`;
    const d = `${day}-${month}-${year}${time}`;
    return d;
  };

  const prepareManuallyDefinedShare = () => {
    let manually_define_MS_List = [];
    if (
      marketShareComparisonList != undefined &&
      marketShareComparisonList != null &&
      marketShareComparisonList.length > 0
    ) {
      for (let i = 0; i < marketShareComparisonList.length; i++) {
        let mdList = {};
        mdList.id = marketShareComparisonList[i].id;
        mdList.share = Number(marketShareComparisonList[i].manually_Defined_MS);
        mdList.name = marketShareComparisonList[i].name;
        mdList.type = marketShareComparisonList[i].type;
        manually_define_MS_List.push(mdList);
      }
    }
    return manually_define_MS_List;
  };

  const clearErrors = () =>{
    dispatch(setState("section_Scenario_Parameteres", false));
    dispatch(setState("section_SKU", false));
    dispatch(setState("section_Customer", false));
    dispatch(setState("section_Datasources", false));
    dispatch(setState("section_Scenario_Settings", false));
  }

  const handleSubmit = () => {
    clearErrors();
    if (!submitDataIsValid()) {
      return;
    }
    const CustObj = getIDsFromList(selectedCustsCGs, "C");
    const prodObj = getIDsFromList(selectedPGs, "P");
    const data = JSON.parse(localStorage.getItem("data"));
    const scDSList = prepareScenarioDSAlignment();
    const manually_Defined = prepareManuallyDefinedShare();
    let referenceSKUList = "";
    if (selectedReferenceSKU.length === 0) {
      referenceSKUList = refList;
    } else {
      referenceSKUList = selectedReferenceSKU
        ?.filter((y) => y.id != 0)
        .map((x) => x.id)
        .join();
    }
    let userName = data.firstName + " " + data.lastName;
    let today = changeDateFormatforComments();
    let cmnts = comments;
    if (cmnts != undefined) {
      if (cmnts.indexOf(userName) <= 0)
        cmnts = cmnts + " (" + userName + ") " + today.toLocaleString();
    }
    const submitData = {
      countryID,
      emailNotification,
      notificationEmailAddress: email,
      skuBreakdown,
      criticalityId: criticalityId,
      periodType,
      customerBreakdownType,
      customerBreakdown,
      scenarioName,
      primaryDataSourceID,
      minimumQuota,
      comments: cmnts,
      lstScenarioCustomers: CustObj.unitStr,
      lstScenarioCustomerGroups: CustObj.groupStr,
      lstScenarioSKUs: prodObj.unitStr,
      lstScenarioProducts: prodObj.groupStr,
      scenarioDataSourceAlignment: scDSList,
      userid: data.userID,
      roleName: data.roleName,
      isEdit: editMode,
      email: email,
      displayStickToQuota: selectedScSTQ === "Enabled" ? 1 : 0,
      unblockFullOrder : selectedScUB === "Enabled" ? 1 : 0,
      modifyStickToQuota : selectedScModifySTQ === "Enabled" ? 1 : 0,
      sentToSAP: sentToSAP ? "N" : "NA",
      SentToSAP4PLExport: sentToSAP ? 0 : 1,
      stickToQuota: selectedScSTQ === "Enabled" ? 1 : 0,
      scenarioStatus: "Draft",
      effectiveStartDate: changeDateFormat(createFromDate),
      effectiveEndDate: changeDateFormat(createToDate),
      updatedBy: data.firstName + " " + data.lastName,
      updatedDate: changeDateFormat(dayjs()),
      scenarioSafetyMargins: [
        {
          trustLevelID: 1,
          trustDesc: "High",
          safetyMargin: DSMHigh,
        },
        {
          trustLevelID: 2,
          trustDesc: "Medium",
          safetyMargin: DSMMed,
        },
        {
          trustLevelID: 3,
          trustDesc: "Low",
          safetyMargin: DSMLow,
        },
        {
          trustLevelID: 4,
          trustDesc: "Others/Customer Group",
          safetyMargin: DSMOth,
        },
      ],
      ScenarioSafetyMarginType: SafetyMargin,
      LinearFCTimePeriod: selectedLinearTrend,
      RunRateTimePeriod: selectedRunRate,
      FinancialFCTimePeriod: selectedConsensus,
      PreviousYearTimePeriod: selectedPreviousYear,
      QuotaDeviationPercentage: quotaDeviationPercentage,
      ModificationDeviationPercentage: modificationDeviationPercentage,
      DefaultInitialForecast: selectedDefaultInitialForecast,
      scenarioExternalDataSource: scenarioExternalDataSource,
      SKUExternalBreakdown: scenarioExternalDataSourceSKU,
      referenceSKUList: referenceSKUList,
      manuallyDefinedShare: manually_Defined,
      marketShareComparisonPeriod: MarketShareTimePeriod,
    };

    console.log("Create Summary", submitData);
    dispatch(submitScenario(submitData));
  };
  const handleSave = () => {
    clearErrors();
    if (!submitDataIsValid()) {
      return;
    }
    const CustObj = getIDsFromList(selectedCustsCGs, "C");
    const prodObj = getIDsFromList(selectedPGs, "P");
    const data = JSON.parse(localStorage.getItem("data"));
    const scDSList = prepareScenarioDSAlignment();
    const manually_Defined = prepareManuallyDefinedShare();
    let referenceSKUList = "";
    if (selectedReferenceSKU.length === 0) {
      referenceSKUList = refList;
    } else {
      referenceSKUList = selectedReferenceSKU
        ?.filter((y) => y.id != 0)
        .map((x) => x.id)
        .join();
    }
    let userName = data.firstName + " " + data.lastName;
    let today = changeDateFormatforComments();
    let cmnts = comments;
    if (cmnts != undefined) {
      if (cmnts.indexOf(userName) <= 0)
        cmnts = cmnts + " (" + userName + ") " + today.toLocaleString();
    }
    const saveData = {
      countryID,
      emailNotification,
      notificationEmailAddress: email,
      skuBreakdown,
      criticalityId: criticalityId,
      periodType,
      customerBreakdownType,
      customerBreakdown,
      scenarioName,
      primaryDataSourceID,
      minimumQuota,
      comments: cmnts,
      lstScenarioCustomers: CustObj.unitStr,
      lstScenarioCustomerGroups: CustObj.groupStr,
      lstScenarioSKUs: prodObj.unitStr,
      lstScenarioProducts: prodObj.groupStr,
      scenarioDataSourceAlignment: scDSList,
      userid: data.userID,
      roleName: data.roleName,
      isEdit: editMode,
      email: email,
      displayStickToQuota: selectedScSTQ === "Enabled" ? 1 : 0,
      unblockFullOrder : selectedScUB === "Enabled" ? 1 : 0,
      modifyStickToQuota : selectedScModifySTQ === "Enabled" ? 1 : 0,
      sentToSAP: sentToSAP ? "N" : "NA",
      SentToSAP4PLExport: sentToSAP ? 0 : 1,
      stickToQuota: selectedScSTQ === "Enabled" ? 1 : 0,
      scenarioStatus: "Draft",
      effectiveStartDate: changeDateFormat(createFromDate),
      effectiveEndDate: changeDateFormat(createToDate),
      updatedBy: data.firstName + " " + data.lastName,
      updatedDate: changeDateFormat(dayjs()),
      scenarioSafetyMargins: [
        {
          trustLevelID: 1,
          trustDesc: "High",
          safetyMargin: DSMHigh,
        },
        {
          trustLevelID: 2,
          trustDesc: "Medium",
          safetyMargin: DSMMed,
        },
        {
          trustLevelID: 3,
          trustDesc: "Low",
          safetyMargin: DSMLow,
        },
        {
          trustLevelID: 4,
          trustDesc: "Others/Customer Group",
          safetyMargin: DSMOth,
        },
      ],
      ScenarioSafetyMarginType: SafetyMargin,
      LinearFCTimePeriod: selectedLinearTrend,
      RunRateTimePeriod: selectedRunRate,
      FinancialFCTimePeriod: selectedConsensus,
      PreviousYearTimePeriod: selectedPreviousYear,
      QuotaDeviationPercentage: quotaDeviationPercentage,
      ModificationDeviationPercentage: modificationDeviationPercentage,
      DefaultInitialForecast: selectedDefaultInitialForecast,
      scenarioExternalDataSource: scenarioExternalDataSource,
      SKUExternalBreakdown: scenarioExternalDataSourceSKU,
      referenceSKUList: referenceSKUList,
      manuallyDefinedShare: manually_Defined,
      marketShareComparisonPeriod: MarketShareTimePeriod,
    };

    console.log("Create Summary", saveData);
    dispatch(saveScenario(saveData));
  };

  return (
    <Box>
      <CollapseSection title="Summary">
        <Box sx={{ mt: 3 }}>
          <Grid container columns={12} columnSpacing={2}>
            {/* <Grid item sm={11} md={12}>
						<Box sx={{mb: 2}}>
							<Typography sx={{ color: "lightBlue.main", fontWeight: 700, }} className="compHeading">Summary</Typography>
						</Box>
					</Grid> */}
            <Grid item sm={1} md={1} sx={{ ml: "calc(100% - 120px)", mt: -4 }}>
              <ExportExcelPDF />
            </Grid>
          </Grid>
        </Box>

        <Box>
          <Box sx={{ mb: 1.2 }}>
            <Typography display="inline" sx={{ fontWeight: "600" }}>
              Scenario Name:{" "}
            </Typography>
            <Typography display="inline">{scenarioName}</Typography>
          </Box>
          <Box sx={{ mb: 1.2 }}>
            <Typography sx={{ fontWeight: "600" }} display="inline">
              Country:
            </Typography>
            <Typography display="inline">{selectedCountry}</Typography>
          </Box>
          <Box sx={{ mb: 1.2 }}>
            <Typography sx={{ fontWeight: "600" }} display="inline">
              Validity Period:{" "}
            </Typography>
            <Typography display="inline">
              {createFromDate === null
                ? ""
                : typeof createFromDate === "string"
                ? moment(createFromDate).format("DD/MM/YYYY")
                : moment(changeDateFormat(createFromDate)).format(
                    "DD/MM/YYYY"
                  )}{" "}
              To{" "}
              {createToDate === null
                ? ""
                : typeof createToDate === "string"
                ? moment(createToDate).format("DD/MM/YYYY")
                : moment(changeDateFormat(createToDate)).format("DD/MM/YYYY")}
            </Typography>
          </Box>
          <Box sx={{ mb: 1.2 }}>
            <Typography sx={{ fontWeight: "600" }} display="inline">
              Period Type:
            </Typography>
            <Typography display="inline">{periodType}</Typography>
          </Box>
          <Box sx={{ mb: 1.2 }}>
            <Typography sx={{ fontWeight: "600" }} display="inline">
              SKU(s):
            </Typography>
            <Typography display="inline">
              {listToNameString(selectedPGs, "P")}
            </Typography>
          </Box>
          <Box sx={{ mb: 1.2 }}>
            <Typography sx={{ fontWeight: "600" }} display="inline">
              Product Group(s):
            </Typography>
            <Typography display="inline">
              {listToNameString(selectedPGs, "PG")}
            </Typography>
          </Box>
          <Box sx={{ mb: 1.2 }}>
            <Typography sx={{ fontWeight: "600" }} display="inline">
              Customer Group(s):
            </Typography>
            <Typography display="inline">
              {listToNameString(selectedCustsCGs, "CG")}
            </Typography>
          </Box>
          <Box>
            <Box>
              <Typography sx={{ fontWeight: "600" }}>Customer(s):</Typography>
              {/* <Typography sx={{ fontWeight: "bold" }}  display="inline">
						{listToNameString(selectedCustsCGs, "C")}{" "}
					</Typography> */}
              <Typography
                sx={{ fontSize: "14px", mb: 2 }}
                onClick={() => handleClick("name")}
                display="inline"
                sm={{ cursor: "pointer" }}
              >
                Sort by Name |
              </Typography>{" "}
              <Typography
                sx={{ fontSize: "14px", mb: 2 }}
                onClick={() => handleClick("number")}
                display="inline"
                sm={{ cursor: "pointer" }}
              >
                Sort by Number
              </Typography>
            </Box>
            <Box  mb={1.2}>
              <TextField
                className={"fullHeight"}
                overflow="scroll"
                multiline
                id="outlined-basic"
                label=""
                rows={6}
                variant="outlined"
                size="large"
                value={listToNameStringCustomers(CustomerList, "C")}
                style={{ overflowY: "auto" }}
              />
            </Box>
          </Box>
          <Box sx={{ mb: 1.2 }}>
            <Typography sx={{ fontWeight: "600" }} display="inline">
              Data Sources:{" "}
            </Typography>
            <Typography display="inline">{getDataSourcesString()}</Typography>
          </Box>
          <Box sx={{ mb: 1.2 }}>
            <Typography sx={{ fontWeight: "600" }} display="inline">
              Customer Breakdown Methodologies:{" "}
            </Typography>
            <Typography display="inline">
              {customerBreakdownType} {customerBreakdown}
            </Typography>
          </Box>
          <Box sx={{ mb: 1.2 }}>
            <Typography sx={{ fontWeight: "600" }} display="inline">
              SKU Breakdown Methodologies:{" "}
            </Typography>
            <Typography display="inline">{skuBreakdown}</Typography>
          </Box>

          <Box sx={{ mb: 1.2 }}>
            <Typography sx={{ fontWeight: "bold" }}>Comments</Typography>
          </Box>

          <Box sx={{ mb: 1.2 }}>
            <TextField
              className={"fullHeight"}
              overflow="scroll"
              multiline
              id="outlined-basic"
              label=""
              rows={6}
              variant="outlined"
              size="large"
              value={comments}
              style={{ overflowY: "auto" }}
              onChange={(event) => handleStateUpdate(event, "comments")}
            />
          </Box>
        </Box>
      </CollapseSection>
      <Box
        sx={{
          diplay: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
        }}
      >
        {/* <Button
          startIcon={<CheckIcon />}
          disabled={!isRestrictedAccess}
          sx={{
            bgcolor: "skyBlue.main",
            color: "blue.main",
            textTransform: "none",
            mt: 6,
            mr: 2,
            "&:hover": {
              bgcolor: "lightBlue.main",
              color: "white.main",
            },
          }}
        >
          Verify Scenario
        </Button>
      </Box> */}

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
        }}
      >
        <Box>
          <Button
            startIcon={<SaveIcon />}
            disabled={!isRestrictedAccess}
            sx={{
              bgcolor: "skyBlue.main",
              color: "blue.main",
              textTransform: "none",
              mt: 3,
              mr: 2,
              "&:hover": {
                bgcolor: "lightBlue.main",
                color: "white.main",
              },
            }}
            onClick={handleSave}
          >
            Save Scenario
          </Button>
        </Box>
        <Box>
            <Button
              startIcon={<CheckIcon />}
              disabled
              sx={{
                bgcolor: "skyBlue.main",
                color: "blue.main",
                textTransform: "none",
                mt: 3,
                mr: 2,
                "&:hover": {
                  bgcolor: "lightBlue.main",
                  color: "white.main",
                },
              }}
            >
              Verify Scenario
            </Button>
        </Box>

        <Box>
          <Button
            startIcon={<FileUploadIcon />}
            disabled={!isRestrictedAccess}
            sx={{
              bgcolor: "blue.main",
              color: "white.main",
              textTransform: "none",
              mt: 3,
              "&:hover": {
                bgcolor: "skyBlue.main",
                color: "blue.main",
              },
            }}
            onClick={handleSubmit}
          >
            Submit Scenario
          </Button>
        </Box>
        </Box>
      </Box>
    </Box>
  );
}
